// extracted by mini-css-extract-plugin
export default {"field-wrapper":"SingleFieldV3_field-wrapper__KoLa+"};